<template>
  <div>
    <base-list-management
      ref="baseListManagement"
      :configData.sync="configData"
    >
      <template slot="custom-export">
        <el-button
          v-if="judgePermission('under_lease_driver_risk_control_export')"
          :loading="oLoading.export"
          @click="asycnExportHandle"
        >
          导出
        </el-button>
        <el-button
          class="ml10"
          v-if="judgePermission('under_lease_driver_risk_control_export')"
          @click="exportDataHandle"
        >
          导出列表
        </el-button>
      </template>
      <template slot="custom-operate">
        <div class="btnArea">
          <el-button
            v-if="judgePermission('under_lease_driver_risk_control_config')"
            @click="setRule"
            type="primary"
          >
            预警规则设置
          </el-button>
        </div>
      </template>
    </base-list-management>
    <!-- 跟进 -->
    <followUp ref="followUpRef" :id="warnId" @followSuccess="search" />
    <!-- 预警规则设置 -->
    <riskWarnRuleSetting ref="riskWarnRuleSettingRef" @setSuccess="search" />
    <!-- 导出列表 -->
    <exportListDialog
      :taskType="2"
      v-if="dialogObj.visible"
      :dialogVisible="dialogObj.visible"
      @close="dialogObj.visible = false"
    />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-cycle
import config from './config/list'
import { parseQueryJsonStr } from '@/utils/querySchema'
import { FuzzySearch } from '@/api/domain/cars'
import { searchByCustomerNameSensitive } from '@/api/domain/customers'
import { exportRisk } from '@/api/domain/orders'
import followUp from './components/followUp'
import riskWarnRuleSetting from './components/riskWarnRuleSetting'
import exportListDialog from './components/exportListDialog.vue'
import * as Sentry from '@sentry/vue'

export default {
  components: { followUp, riskWarnRuleSetting, exportListDialog },
  data() {
    const { query: queryStr } = this.$route?.query
    const queryObj = queryStr ? parseQueryJsonStr(queryStr) : {}
    const { configData } = config.call(this)
    return {
      dialogObj: { visible: false },
      exportParams: {},
      configData,
      warnId: '',
      oLoading: {
        export: false,
      },
      queries: queryObj,
      // eslint-disable-next-line vue/no-unused-properties
      style: {
        customerName: `float: left ;width: 60px ;height: 35px ;overflow: hidden ;
                      text-overflow: ellipsis ;white-space: nowrap ;`,
        customerTel:
          'float: left ;color: #8492a6 ;font-size: 13px ;margin: 0 ;padding-left: 10px ;',
      },
    }
  },
  computed: {},
  methods: {
    getRouteQuery() {
      const { search = {} } = this.queries
      const { state = '', time = '', level = '' } = search

      if (state !== '') {
        this.configData.formData.formProps.model.state = state
      }
      if (time !== '') {
        this.configData.formData.formProps.model.time = time
      }
      if (level !== '') {
        this.configData.formData.formProps.model.level = level
      }
    },
    // 异步导出数据
    async asycnExportHandle() {
      this.oLoading.export = true
      try {
        const { code } = await exportRisk(this.exportParams)
        if (code === 1) {
          this.$message.success(
            '所选数据已生成下载文件，请点击【导出列表】查看下载',
          )
        }
        this.oLoading.export = false
      } catch (_) {
        this.oLoading.export = false
      }
    },
    // 获取参数并查询
    // eslint-disable-next-line vue/no-unused-properties
    getParams(params) {
      if (params.time && params.time.length > 0) {
        params.startTime = params.time[0]
        params.endTime = params.time[1]
      }
      params.sorted = this.sortChange(params.sorter)
      // 处理导出参数
      this.exportParams = JSON.parse(JSON.stringify(params))
      this.exportParams.pageNum = ''
      this.exportParams.pageSize = ''
      return params
    },
    /* 车牌号 */
    // eslint-disable-next-line vue/no-unused-properties
    async remoteMethod(query) {
      if (query.length >= 4) {
        try {
          const { data } = await FuzzySearch({
            plateNo: query,
            state: 1,
          })
          this.$refs.baseListManagement.setItemData({
            elConfigKey: 'list',
            key: 'carId',
            data,
          })
        } catch (error) {
          Sentry.captureException(error)
        }
      }
    },
    // 获取客户列表
    // eslint-disable-next-line vue/no-unused-properties
    async loadNameData(query) {
      if (query.length >= 1) {
        // 客户类型 1个人 2企业
        const { data } = await searchByCustomerNameSensitive({
          customerType: 1,
          customerName: query,
        })
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'list',
          key: 'customerId',
          data: data || [],
        })
      }
    },
    // 排序改变触发
    sortChange(data) {
      if (!data) return 0
      //  默认排序 0， 风险等级排序升序排序 1， 风险等级排序降序排序 2， 押金比例升序排序 3， 押金比例降序排序 4，预警开始时间升序 5， 预警开始时间降序 6， 预警时长升序 7， 预警时长降序 8
      const obj = {
        warnLevel: [1, 2],
        depositRatio: [3, 4],
        startTime: [5, 6],
        warnDuration: [7, 8],
      }
      const { prop, order } = data
      // order === 'descending' // 降序
      let index = ''
      if (order) {
        if (order === 'descending') {
          index = 1
        } else {
          index = 0
        }
      }

      const sortId = obj[prop][index]
      return sortId
    },
    // 跟进
    // eslint-disable-next-line vue/no-unused-properties
    followUp(row) {
      this.warnId = row.id
      this.$refs.followUpRef.showDialog()
    },
    // 预警规则设置
    setRule() {
      this.$refs.riskWarnRuleSettingRef.showDialog()
    },
    // eslint-disable-next-line vue/no-unused-properties
    lookDetail(row) {
      this.$router.push({
        path: '/underLease/riskControl/riskDetail',
        query: { id: row.id },
      })
    },
    search() {
      this.$refs.baseListManagement.searchForm()
    },
    // 导出列表
    exportDataHandle() {
      this.dialogObj = {
        visible: true,
        title: '导出列表',
      }
    },
  },
  mounted() {
    this.getRouteQuery()
  },
}
</script>
<style scoped lang="scss">
.ml10 {
  margin-left: 10px;
}
.export {
  display: inline-block !important;
}
.btnArea {
  display: flex;
}
</style>
